import { UAParser } from 'ua-parser-js';

import { isMobile } from './deviceInfo';
import { isProd } from './enviroments';
import {
    getMultipleStorageValues,
    getStorageValue,
    setStorageValue,
} from './localStorageHandler';

export const getLeadExtraData = ({
    storageKey,
    urlParams,
    botInfo,
    offerRefId,
    consentId,
    leadExtraData,
    onesignalId,
}) => {
    const {
        ['pwa.status']: pwaStatusValue,
        ['app.offerId']: appOfferId, // currently unused, but available if needed
    } = getMultipleStorageValues(storageKey, ['pwa.status', 'app.offerId']);

    const { rid, refid1, refid2, refid3 } = urlParams;
    const { visitorId, isBot, failedChecks } = botInfo;
    const offerId = offerRefId || appOfferId;

    const extraData = {};
    extraData.isbt = isBot; // stands for is_bot
    extraData.fngptid = visitorId; // stands for fingerprint_id
    extraData.btfldchk = failedChecks; // stands for bot_failed_checks
    extraData.consent_id = consentId;
    extraData.device = isMobile() ? 'mobile' : 'desktop';

    if (leadExtraData && typeof leadExtraData === 'object')
        Object.assign(extraData, leadExtraData);
    if (pwaStatusValue === 'Installed') extraData.pwa_install = 'true';

    return {
        rid,
        refid1,
        refid2,
        refid3,
        offerId,
        extraData,
        setStorage: false,
        device_id: onesignalId,
    };
};

export const getAddLeadCountParams = ({
    botInfo,
    urlParams,
    campaignId,
    onesignalId,
    storageKey,
}) => {
    const {
        os: { name: osName, version: osVersion },
        browser: { name, version },
    } = new UAParser().getResult();
    const {
        ['app.cmpId']: storageCampaignId,
        ['push.brwPromptCount']: storageBrowserPushPromptCount,
        ['push.promptAllowPressed']: storagePromptAllowPressed,
    } = getMultipleStorageValues(storageKey, [
        'app.cmpId',
        'push.brwPromptCount',
        'push.promptAllowPressed',
    ]);
    const { visitorId, isBot, failedChecks } = botInfo;
    const { hash, refid1, refid2, refid3 } = urlParams;
    const campId = storageCampaignId || campaignId;

    const parsedPromptCount = Number(storageBrowserPushPromptCount);
    const browserPushPromptCount = Number.isFinite(parsedPromptCount)
        ? parsedPromptCount
        : 0;

    const parsedPromptPressed = Number(storagePromptAllowPressed);
    const promptAllowPressed = Number.isFinite(parsedPromptPressed)
        ? parsedPromptPressed + 1
        : 1;

    setStorageValue(storageKey, 'push.promptAllowPressed', promptAllowPressed);

    return {
        isBot,
        campaignId: campId,
        browser: `${name} ${version}`,
        device: `${osName} ${osVersion}`,
        uuid: isProd() ? refid3 : `${refid2}_${refid3}`,
        extraData: {
            fngptid: visitorId,
            browser_push_prompt_count: browserPushPromptCount,
            push_prompt_allow_pressed_count: promptAllowPressed,
            ...(failedChecks.length > 0 && {
                btfldchk: failedChecks,
            }),
        },
        ...(hash && { hash, refid1, deviceId: onesignalId }),
    };
};

export const updateStorageCampaignValue = (hash, campaignId, storageKey) => {
    const storageCampaign = getStorageValue(storageKey, 'app.cmpId');
    const updateStorage =
        !hash && (!storageCampaign || storageCampaign !== campaignId);

    if (updateStorage) {
        setStorageValue(storageKey, 'app.cmpId', campaignId);
    }
};
